import { MenuItemType } from '@nx-frontend/shared/types';

/**
 * Menu items ids stored in format `MenuItemType#id`, this function parses them
 * @param menuItemId
 * @returns
 */
export function parseMenuItemId(menuItemId: string): { id: string; type: MenuItemType } {
  const [type, id] = menuItemId.split('#');
  return { id, type: type as MenuItemType };
}
